import React from 'react';
import LegalLayout, { COMPANY, H2, P, UL } from './LegalLayout';

const SLA: React.FC = () => (
  <LegalLayout
    slug="sla"
    title="Service Level Agreement"
    description="12and22's 99.9% uptime commitment and service-credit remedies."
  >
    <P>
      This Service Level Agreement (&ldquo;SLA&rdquo;) sets out the uptime commitment for hosting and VPS
      Services provided by {COMPANY.legalName} ({COMPANY.brand}) and the service credits available if we
      do not meet it. It forms part of our Terms of Service.
    </P>

    <H2>Uptime commitment</H2>
    <P>
      We target <strong>99.9% network and server availability per calendar month</strong> for hosting
      and VPS Services, measured at our infrastructure. &ldquo;Availability&rdquo; means your Service is reachable
      and responding; it excludes the conditions listed below.
    </P>

    <H2>Service credits</H2>
    <P>
      If monthly availability falls below 99.9%, you may request a service credit applied to a future
      invoice, calculated as a percentage of that month&apos;s fee for the affected Service:
    </P>
    <UL>
      <li>99.0% to &lt; 99.9% &mdash; 10% credit</li>
      <li>95.0% to &lt; 99.0% &mdash; 25% credit</li>
      <li>Below 95.0% &mdash; 50% credit</li>
    </UL>
    <P>
      Credits are the sole and exclusive remedy for availability shortfalls. Total credits in any month
      will not exceed that month&apos;s fee for the affected Service, and credits are applied to your
      account rather than paid in cash.
    </P>

    <H2>Exclusions</H2>
    <P>These commitments do not apply to downtime caused by:</P>
    <UL>
      <li>Scheduled or emergency maintenance (we aim to give advance notice for scheduled work).</li>
      <li>Factors outside our reasonable control, including force majeure, upstream network or power
        failures, and third-party registry, registrar, or DNS provider issues.</li>
      <li>Your applications, code, configuration, or third-party software.</li>
      <li>Suspension or termination for non-payment or Acceptable Use Policy violations.</li>
      <li>DNS not yet pointing to our servers, or issues with domains not managed by us.</li>
    </UL>

    <H2>Claiming a credit</H2>
    <P>
      To request a credit, open a support ticket or email{' '}
      <a href={`mailto:${COMPANY.supportEmail}`} className="text-primary-navy underline">{COMPANY.supportEmail}</a>{' '}
      within 30 days of the affected month, including the dates and times of the outage. We will verify
      against our monitoring records and apply any approved credit to your next invoice.
    </P>
  </LegalLayout>
);

export default SLA;
